import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import EntranceIndex from '@/pages/home/components/EntranceIndex';
import WhyBookmark from '@/pages/home/components/WhyBookmark';
import AddressList from '@/pages/home/components/AddressList';
import AppDownload from '@/pages/home/components/AppDownload';
import TagWall from '@/pages/home/components/TagWall';
import StepsGuide from '@/pages/home/components/StepsGuide';
import Faq from '@/pages/home/components/Faq';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <EntranceIndex />
        <WhyBookmark />
        <AddressList />
        <AppDownload />
        <TagWall />
        <StepsGuide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}